import { getPartnerFromUrl } from '@/partners/getPartnerFromUrl';

import { getInitialApplicationData } from './helpers/getInitialApplication/getInitialApplicationData';
import { setInitialApplication } from './helpers/setInitialApplication/setInitialApplicationData';
import {
    getInitialBorrowerData,
    getInitialDisplayData,
    getInitialLoanData,
    getInitialSellerData,
    getInitialVehicleData,
    getParameters,
    setInitialBorrower,
    setInitialDisplay,
    setInitialLoan,
    setInitialSeller,
    setInitialUserState,
    setInitialVehicle,
} from './helpers';

export async function setParametersFromParams(): Promise<void> {
    const params = getParameters();
    const partner = await getPartnerFromUrl();

    // Initial Setup - From Cookies and URL token
    await setInitialUserState();

    // Setup data
    const sellerData = getInitialSellerData(partner, params);
    const vehicleData = getInitialVehicleData(partner, params);
    const loanData = getInitialLoanData(partner, params);
    const displayData = getInitialDisplayData(partner, params);
    const borrowerData = getInitialBorrowerData(partner, params);
    const applicationData = getInitialApplicationData(partner, params);

    // Apply critical URL-driven data first to avoid BE hydration overwriting it
    await setInitialVehicle(vehicleData);
    await setInitialLoan(loanData);

    // Set remaining data in parallel
    await Promise.all([
        setInitialBorrower(borrowerData, displayData.initialJourney),
        setInitialSeller(sellerData),
        setInitialApplication(applicationData, partner.id),
    ]);

    // Display last (may trigger getBorrower for return users)
    setInitialDisplay(displayData);
}
